export enum CostsType {
  PAYED_BY_US = 'payed_by_us',
  PAYED_BY_VENDOR = 'payed_by_vendor',
}
